import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AccountingIntegration = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Muhasebe Entegrasyonu
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Logo muhasebe entegrasyonu burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default AccountingIntegration;
